import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetCoreModule } from '@gspwidget/widget-core';
import { ConfigEditor2Module } from './config-editor2/config-editor2.module';
import { HelpModule } from './help/help.module';
import { EppPasswordModule } from './password/password.module';
import { SearchInputModule, SearchInputComponent } from '@gspwidget/util';
import { WidgetProjectPreviewPageModule } from './widget-project-preview-page/widget-project-preview-page.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetCoreModule,
    SearchInputModule,
    HelpModule,
  ],
  exports: [
    SearchInputComponent,
    WidgetProjectPreviewPageModule,
    ConfigEditor2Module,
    HelpModule,
    EppPasswordModule,
  ]
})
export class DashboardCommonModule { }
